import Vue from 'vue'

Vue.directive('sensitive', {
  bind (el) {
    el.removeAttribute('name')
  }
})

Vue.directive('click-outside', {
  bind (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      if (!(el === event.target || el.contains(event.target))) {
        if (binding.expression) {
          vnode.context[binding.expression](event)
        }
      }
    }
    if (document && document.body) {
      document.body.addEventListener('click', el.clickOutsideEvent)
    }
  },
  unbind (el) {
    if (document && document.body) {
      document.body.removeEventListener('click', el.clickOutsideEvent)
    }
  }
})
